import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class ProvinceService {

constructor(private http:HttpClient) { }


GetRecord(id:String):Observable<Array<General_Interface>>{
  return this.http.get(environment.BaseUrl + "Daro/Province?id="+id).pipe(
    map(data=>{
      return data as Array<General_Interface>
    })
  )
}


}
